<template>
  <div>
    <h3 class="title-page">{{ $t("history") }}</h3>
    <div class="mdm-table">
      <div>
        <v-row class="flex-wrap">
          <v-col lg="4" sm="6" cols="12">
            <v-card
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
              @click="$router.push({ name: 'contract-history' })"
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-card-title style="word-break: normal">{{
                    $tc("contractHistory")
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col lg="4" sm="6" cols="12">
            <v-card
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
              @click="$router.push({ name: 'contract-history-item' })"
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-card-title style="word-break: normal">{{
                    $tc("contractHistory", 0)
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col lg="4" sm="6" cols="12">
            <v-card
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
              @click="$router.push({ name: 'order-history' })"
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-card-title style="word-break: normal">{{
                    $tc("orderHistory")
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col lg="4" sm="6" cols="12">
            <v-card
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
              @click="$router.push({ name: 'order-history-item' })"
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-card-title style="word-break: normal">{{
                    $tc("orderHistory", 0)
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col lg="4" sm="6" cols="12">
            <v-card
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
              @click="$router.push({ name: 'product-history' })"
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-calendar-month</v-icon>
                  <v-card-title style="word-break: normal">{{
                    $t("productHistory")
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "index.scss";
</style>
